export const getSurveysByType = (surveys) => {
    return surveys.reduce((acc, survey) => {
        if (survey.type === "one_time") {
            acc.oneTimeSurveys.push(survey);
        }
        else if (survey.type === "recurring") {
            acc.recurringSurveys.push(survey);
        }
        return acc;
    }, { oneTimeSurveys: [], recurringSurveys: [] });
};
//# sourceMappingURL=getSurveysByType.js.map